module.exports = __webpack_public_path__ + "img/lembur.5b59de6c.png";